import { render, staticRenderFns } from "./routing.vue?vue&type=template&id=3159f3d4&scoped=true&"
import script from "./routing.vue?vue&type=script&lang=js&"
export * from "./routing.vue?vue&type=script&lang=js&"
import style0 from "./routing.vue?vue&type=style&index=0&id=3159f3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159f3d4",
  null
  
)

export default component.exports